/**
 * Transfer Listing Images API Endpoint Schemas
 *
 * POST /api/transfer/[listingId]
 * Transfers listing images from production to dev/staging S3 buckets
 */

import { z } from 'zod';

// Request schema (query params)
export const TransferRequestSchema = z.object({
  listingId: z.string().min(1, 'Listing ID is required'),
});

export type TransferRequest = z.infer<typeof TransferRequestSchema>;

// Success response schema
export const TransferSuccessSchema = z.object({
  success: z.literal(true),
  listingId: z.number(),
  transferred: z.number(),
  skipped: z.number(),
  failed: z.number().optional(),
  deleted: z.boolean(),
  message: z.string().optional(),
  duration: z.number().optional(),
});

export type TransferSuccess = z.infer<typeof TransferSuccessSchema>;

// Error response schema
export const TransferErrorSchema = z.object({
  error: z.string(),
});

export type TransferError = z.infer<typeof TransferErrorSchema>;

// Combined response schema (note: this doesn't use discriminatedUnion as error doesn't have success field)
export const TransferResponseSchema = TransferSuccessSchema;

export type TransferResponse = z.infer<typeof TransferResponseSchema>;
